import React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import moment from 'moment';
import EmployeePay from 'src/models/personnel/EmployeePay';

interface IEmployeePayHistoryDialogProps {
    dialogName: string;
    employeePayHistory: EmployeePay[];
    hideDialog: () => void;
}

const EmployeePayHistoryDialog = (props: IEmployeePayHistoryDialogProps) => {
    const OKClicked = () => {
        props.hideDialog();
    };

    return (
        <Dialog title="Employee Pay History" dialogName={props.dialogName} isExitButtonInvisible={true}>
            {props.employeePayHistory?.length > 0 && <div>
                <div style={{overflowY: 'scroll', maxHeight: '15rem', width: '50vw'}}>
                    <table style={{width: '100%'}}>
                        <thead>
                            <tr style={{background: '#d6d6d6'}}>
                                <th style={{width: '20%'}}>Annual Salary</th>
                                <th style={{width: '20%'}}>Company Day Rate</th>
                                <th style={{width: '20%'}}>Company Hourly Rate</th>
                                <th style={{width: '20%'}}>Guaranteed</th>
                                <th style={{width: '20%'}}>Change Date</th>
                            </tr>
                        </thead>
                        {Array.isArray(props.employeePayHistory) && props.employeePayHistory?.map((pay: EmployeePay, index: number) => {
                            return (
                                <tbody key={pay.id}>
                                    <tr className={pay.isActive ? 'contract-pay-history-active-item' : 'contract-pay-history-item'}>
                                        <td style={{width: '20%'}}>
                                            {pay.annualSalary}
                                        </td>
                                        <td style={{width: '20%'}}>
                                            {pay.companyDayRate}
                                        </td>
                                        <td style={{width: '20%'}}>
                                            {pay.companyHourlyRate}
                                        </td>
                                        <td style={{width: '20%'}}>
                                            {pay.guaranteedRate}
                                        </td>
                                        <td style={{width: '20%'}}>
                                            {moment(pay.changeDate).format('YYYY-MM-DD') as unknown as Date}
                                        </td>
                                    </tr>
                                </tbody>
                            );
                        })}
                    </table>
                </div>
            </div>}
            {props.employeePayHistory?.length <= 0 && <div className="bold-centered">No Employee Pay History</div>}
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center', textAlign: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
            </div>
        </Dialog>
    );
};

export default EmployeePayHistoryDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/EmployeePayHistoryDialog.tsx